import { BFF_SERVICE } from '../../../utils/constants'
import storage from '../../../utils/storageService'

// Файлы (шаблон, логины) отдаются с авторизацией, поэтому не обычной ссылкой
export const downloadFile = async (path: string, fileName: string): Promise<boolean> => {
    const token = storage?.get('token')
    const res = await fetch(`${BFF_SERVICE}/${path}`, {
        headers: token ? { authorization: `Bearer ${token}` } : {},
    })
    if (!res.ok) return false
    const url = URL.createObjectURL(await res.blob())
    const a = document.createElement('a')
    a.href = url
    a.download = fileName
    a.click()
    URL.revokeObjectURL(url)
    return true
}
